import { useEffect, useState } from 'react';
import API from '../api';

export default function StatsAvancees() {
  const [data, setData] = useState(null);

  useEffect(() => {
    API.get('stats/avancees/').then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="loading-screen"><div className="spinner" /><p>Chargement des statistiques…</p></div>;

  return (
    <div>
      <div className="page-header">
        <h2><i className="bi bi-bar-chart-line" /> Statistiques avancées</h2>
        <p>Vue d'ensemble des performances académiques</p>
      </div>

      <div className="form-glass">
        <h3><i className="bi bi-book" /> Performance par cours</h3>
        {data.cours_stats && data.cours_stats.length > 0 ? (
          <div className="data-table-wrapper">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Cours</th>
                  {data.cours_stats[0].enseignant && <th>Enseignant</th>}
                  {data.cours_stats[0].promotion && <th>Promotion</th>}
                  <th>Moyenne</th>
                  <th>Notes</th>
                  <th>Taux de réussite</th>
                </tr>
              </thead>
              <tbody>
                {data.cours_stats.map((cs) => (
                  <tr key={cs.cours_id}>
                    <td>{cs.cours_titre}</td>
                    {cs.enseignant && <td>{cs.enseignant}</td>}
                    {cs.promotion && <td>{cs.promotion}</td>}
                    <td className={cs.moyenne_generale != null ? 'moyenne' : ''}>
                      {cs.moyenne_generale != null ? cs.moyenne_generale.toFixed(2) : cs.moyenne != null ? cs.moyenne.toFixed(2) : '–'}
                    </td>
                    <td>{cs.nb_notes ?? cs.nb_evaluations ?? 0}</td>
                    <td>
                      {cs.taux_reussite != null ? (
                        <span className={cs.taux_reussite >= 50 ? 'taux-ok' : 'taux-fail'}>
                          {cs.taux_reussite}%
                        </span>
                      ) : '–'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <div className="empty-state"><i className="bi bi-clipboard-x" /><p>Aucune donnée disponible</p></div>}
      </div>

      {data.promotion_stats && (
        <div className="form-glass">
          <h3><i className="bi bi-mortarboard" /> Performance par promotion</h3>
          <div className="data-table-wrapper">
            <table className="data-table">
              <thead>
                <tr><th>Promotion</th><th>Étudiants</th><th>Notes</th><th>Taux de réussite</th></tr>
              </thead>
              <tbody>
                {data.promotion_stats.map((ps) => (
                  <tr key={ps.promotion_id}>
                    <td>{ps.promotion}</td>
                    <td>{ps.nb_etudiants}</td>
                    <td>{ps.nb_notes}</td>
                    <td>
                      {ps.taux_reussite != null ? (
                        <span className={ps.taux_reussite >= 50 ? 'taux-ok' : 'taux-fail'}>
                          {ps.taux_reussite}%
                        </span>
                      ) : '–'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
